<template>
  <div class="color-picker">
    <div
      v-for="(color, index) in colors"
      :key="index"
      :style="{ backgroundColor: color }"
      @click="$emit('input', color)"
    >
      <div v-if="color === 'transparent'" class="transparent" />
      <div v-if="color === '#ffffff'" class="white" />
      <div v-if="value === color" class="selection" />
    </div>
  </div>
</template>

<script>
/**
 * Visual components used as settings links.
 * @vue-prop id - link to the setttings page
 */

import { colors } from '@/assets/picker-colors';

export default {
  name: 'SColorPicker',
  props: {
    value: {
      type: String,
      default: '#ffffff',
    },
  },
  data() {
    return {
      colors,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.color-picker > div {
  margin: 0 3.5% 3.5% 0;
  width: calc(7.5% - 2px);
  height: 0;
  padding-bottom: calc(7.5% - 2px);
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  position: relative;
  border-radius: $main-border-radius;
  border: 1px solid #aaa;

  > div.selection {
    position: absolute;
    top: 50%;
    width: 7px;
    height: 7px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: $main-border-radius;
  }
  > div.transparent, > div.white {
    border-radius: $main-border-radius;
    height: 100%;
    width: 100%;
  }
  > div.transparent {
    background: linear-gradient(to top right, #fff calc(50% - 1px), #aaa, #fff calc(50% + 1px) );
    padding-bottom: 100%;
  }
}
</style>
